import React from 'react';

import Icon from '@shared/icon/Icon';

import './timeline.scss';

type TimelineEvent = {
  id: number;
  label: string;
};

type TimelineProps = {
  activeIndex: number;
  events: TimelineEvent[];
};

const Timeline: React.FC<TimelineProps> = ({ activeIndex, events }) => {
  return (
    <div className="timeline">
      {events.map((event, index) => (
        <React.Fragment key={event.id}>
          <div
            className={`timeline-item ${index === activeIndex ? 'active' : ''} ${index < activeIndex ? 'completed' : ''} ${
              index === activeIndex + 1 ? 'next-active' : ''
            }`}
          >
            <span className="timeline-label">{event.label}</span>
            {index <= activeIndex && <Icon className="timeline-icon" name="CiCheck" size={1.4} />}
          </div>
          {index < events.length - 1 && (
            <div
              className={`timeline-line ${index === activeIndex ? 'dashed' : ''} ${index < activeIndex ? 'completed' : ''}`}
            ></div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Timeline;
